import { Card } from "@/components/ui/card";

export const PreviewGallery = () => {
  const previews = [
    {
      title: "Daily Health Dashboard",
      description: "View your personalized health insights, tasks, and wellness scores at a glance.",
      imageSrc: "/lovable-uploads/80b5e293-9a4f-4af2-b262-956c6e6ad763.png"
    },
    {
      title: "AI Assistant & Activities",
      description: "Preview of Gia, your AI health companion, and engaging brain training activities.",
      imageSrc: "/lovable-uploads/fa83e293-3c22-4b73-898a-d36075ec4f71.png"
    }
  ];

  return (
    <div className="space-y-8 px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col space-y-3">
        <h2 className="text-[#1d1d1f] text-[32px] sm:text-[40px] leading-tight font-semibold tracking-tight">
          Application Preview
        </h2>
        <p className="apple-subheading text-lg sm:text-xl">
          Sample screenshots of the application interface
        </p>
      </div>
      
      <div className="grid grid-cols-1 gap-8">
        {previews.map((preview, index) => (
          <Card 
            key={index} 
            className="overflow-hidden animate-fade-in bg-white border border-[#e5e5e7]
                     hover:shadow-lg transition-shadow duration-300"
          >
            <div className="relative">
              <picture>
                <source
                  srcSet={`${preview.imageSrc} 2x`}
                  media="(min-width: 1024px)"
                  type="image/png"
                />
                <source
                  srcSet={preview.imageSrc}
                  media="(min-width: 640px)"
                  type="image/png"
                  sizes="(min-width: 640px) 50vw"
                />
                <source
                  srcSet={preview.imageSrc}
                  media="(max-width: 639px)"
                  type="image/png"
                  sizes="100vw"
                />
                <img
                  src={preview.imageSrc}
                  alt={preview.title}
                  className="w-full h-auto rounded-t-lg object-cover"
                  loading="lazy"
                  decoding="async"
                  style={{
                    imageRendering: '-webkit-optimize-contrast',
                    transform: 'translateZ(0)',
                    backfaceVisibility: 'hidden'
                  }}
                />
              </picture>
              <div className="absolute inset-0 bg-black/5 pointer-events-none" />
            </div>
            <div className="p-8 bg-white">
              <h3 className="apple-heading text-2xl mb-2">{preview.title}</h3>
              <p className="apple-subheading text-lg leading-relaxed">{preview.description}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};